import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';
import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { useLogout } from 'js/hooks/auth';

export const RCStopGaming = () => {
    const logout = useLogout();

    const triggerRealityCheckClosedAPIEvent = useCallback(async (status: string) => {
        if (status === 'decline') {
            await logout({ isManual: true });
        }
    }, [logout]);

    useEffect(() => {
        publicEventsAPIService.on('realityPopup:closed', triggerRealityCheckClosedAPIEvent);

        return () => {
            publicEventsAPIService.off('realityPopup:closed', triggerRealityCheckClosedAPIEvent);
        };
    }, [triggerRealityCheckClosedAPIEvent]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.rcStopGaming]: RCStopGaming });
